import { useState, useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';

export const useDebouncedState = (state: any, set: any, timeout: number = 300) => {
  const [debouncedState, setDebouncedState] = useState(state);

  const debouncedSetRef = useRef(debounce(set, timeout));

  useEffect(() => {
    setDebouncedState(state);
  }, [state]);

  useEffect(() => {
    debouncedSetRef.current(debouncedState);

    return () => {
      debouncedSetRef.current.cancel();
    };
  }, [debouncedState]);

  return [debouncedState, setDebouncedState];
};
